import LocalStorage from "./LocalStorage"

export default class SessionStorage extends LocalStorage
{
    constructor(namespace, name) {
        super(namespace, name);
        this.storage = sessionStorage;
    }
}